export const RPC_FAQ_ENDPOINTS = {
    GET_FAQ_LIST: "/get_frequently_asked_questions_list",
};
